import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AmplifyModelService } from '../services/amplify-model-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private authService = inject(AmplifyModelService);
  private router = inject(Router);

  /**
   * Uses AmplifyModelService.getCurrentUser() (an actual async check against
   * the current Cognito session via aws-amplify/auth) rather than reading
   * AuthenticatorService.authStatus synchronously. On a hard browser
   * navigation - e.g. Stripe Checkout redirecting back to success_url,
   * which lands on a route nested under this guard - Angular bootstraps
   * fresh and authStatus may not have resolved to 'authenticated' yet at the
   * exact moment canActivate() runs, incorrectly sending an already-logged-in
   * user to /login and skipping the route entirely. Awaiting a real session
   * check avoids that race. This also matches the pattern already used by
   * AdminGuard/TechnicianGuard/SalesGuard.
   */
  async canActivate(): Promise<boolean> {
    try {
      const user = await this.authService.getCurrentUser();
      if (user) {
        return true;
      }
      this.router.navigate(['/login']);
      return false;
    } catch (error) {
      this.router.navigate(['/login']);
      return false;
    }
  }
}